<script>
  export default {
    name: "generic-table",
    props: {
      fields: {
        type: Array
      },
      items: {
        required: true
      },
      currentPage: {
        type: Number,
        default: 1
      },
      perPage: {
        type: Number,
        default: 0
      },
      totalRows: {
        type: Number,
        default: 0
      },
      busy: {
        type: Boolean
      },
      sortBy: {
        type: String
      },
      sortDesc: {
        type: Boolean
      },
      search: {
        type: Function
      },
      clear: {
        type: Function
      },
      alert: {
        type: Function
      },
      filters: {
        type: Object
      },
      filterString: {
        type: String
      },
      filterFunction: {
        type: Function
      },
      tableKey: {
        type: String
      },
      hideToolbar: {
        type: Boolean,
        default: false
      },
      hidePagination: {
        type: Boolean,
        default: false
      },
      footClone: {
        type: Boolean,
        default: true
      },
      forceRawTableMode: {
        type: Boolean,
        default: false
      },
      hideSearchResetButtons: {
        type: Boolean,
        default: false
      },
      maxRowMultiplier: {
        type: Number,
        default: 0
      },
      hideDefaultParameters: {
        type: Boolean,
        default: false
      },
      allowColumnCustomization: {
        type: Boolean,
        default: true
      },
      tableClass: {
      },
      forceNonResponsive: {
        type: Boolean,
        default: false
      },
      hideExport: {
        type: Boolean,
        default: false
      },
      getExportDataOverride: {
        type: Function
      },
      exportKey: {
        type: String
      },
      toolbarButtonSize: {
        type: String,
        default: "md"
      }
    },
    created() {
    },
    mounted() {
      window.appHelpers.table.resetFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId);
      this.fieldToggles = window.appHelpers.table.getFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId);
    },
    data() {
      return {
        state: window.appState,
        fieldToggles: {
          version: 1,
          hidden: { },
          visible: { },
        },
        currentSortBy: this.sortBy || '',
        currentSortDesc: this.sortDesc || false,
        tableId: Math.floor(Math.random() * Math.floor(1000000000))
      };
    },
    computed: {
      tableStacked() {
        return (!appHelpers.window.isMobile() || this.forceRawTableMode) ? false : "md";
      },
      tableStickyHeader() {
        return (!this.state.preferences.useFloatingTableHeaders || appHelpers.window.isMobile() || this.forceRawTableMode) 
          ? false 
          : (this.state.preferences.floatingTableHeightPixels ? this.state.preferences.floatingTableHeightPixels.toString() + "px" : "500px");
      },
      tableResponsive() {
        return (this.forceNonResponsive || appHelpers.window.isMobile()) ? false : true;
      },
      visibleFields() {
        let visibleFields = [ ];
        if (this.fields && this.fields.length) {
          this.fields.forEach((field) => {
            if (!this.fieldToggles.hidden[field.key]
              && (!field.isHidden || this.fieldToggles.visible[field.key])
            ) {
              visibleFields.push(field);
            }
          });
        }
        return visibleFields;
      },
      visibleFieldNames() {
        return this.visibleFields.map((field) => field.key);
      },
      massagedFields() {
        let visibleFields = this.visibleFields;
        if (visibleFields && visibleFields.length) {
          let originalOrder = [];
          visibleFields.forEach((field) => {
            originalOrder.push(field);
          });
          let customOrder = [];
          if (this.fieldToggles.order && this.fieldToggles.order.length) {
            this.resetable = true;
            this.fieldToggles.order.forEach((order) => {
              let fieldIndex = originalOrder.findIndex((origField) => origField.key === order);
              if (fieldIndex >= 0) {
                customOrder.push(originalOrder[fieldIndex]);
                originalOrder.splice(fieldIndex, 1);
              }
            });
            originalOrder.forEach((originalOrderField) => {
              if (['actions', 'item', 'select'].indexOf(originalOrderField.key.toLowerCase()) >= 0 || originalOrderField.stickyColumn) {
                customOrder.splice(0, 0, originalOrderField);
              } else {
                customOrder.push(originalOrderField);
              }
            });
          } else {
            customOrder = originalOrder;
          }

          return customOrder.map((f) => {
            if (typeof f === 'object') {
              let newField = {};
              Object.assign(newField, f);
              if (this.forceRawTableMode) {
                if (newField.stickyColumn) {
                  newField.stickyColumn = false;
                }
              }
              return newField;
            } else {
              return f;
            }
          });
        }
        return visibleFields;
      },
      syncedBusy: {
        get() {
          return this.busy;
        },
        set(newValue) {
          this.$emit('update:busy', newValue);
        }
      },
      syncedSortBy: {
        get() {
          return this.currentSortBy;
        },
        set(newValue) {
          this.currentSortBy = newValue;
          this.$emit('update:sortBy', newValue);
        }
      },
      syncedSortDesc: {
        get() {
          return this.currentSortDesc;
        },
        set(newValue) {
          this.currentSortDesc = newValue;
          this.$emit('update:sortDesc', newValue);
        }
      },
      syncedFilters: {
        get() {
          return this.filters;
        },
        set(newValue) {
          this.$emit('update:filters', newValue);
          //TODO: Figure out a better way than the dirty hacks below
          if (typeof newValue.sortField === 'string') {
            this.currentSortBy = newValue.sortField;
            this.$emit('update:sortBy', newValue.sortField);
          }
          if (typeof newValue.sortDescending === 'boolean') {
            this.currentSortDesc = newValue.sortDescending;
            this.$emit('update:sortDesc', newValue.sortDescending);
          }
        },
      },
      syncedCurrentPage: {
        get() {
          return this.currentPage;
        },
        set(newValue) {
          this.$emit('update:currentPage', newValue);
        }
      },
      syncedPageSize: {
        get() {
          return this.perPage;
        },
        set(newValue) {
          this.$emit('update:perPage', newValue);
        }
      },
      syncedTotalRows: {
        get() {
          return this.totalRows;
        },
        set(newValue) {
          this.$emit('update:totalRows', newValue);
        }
      },
      localItems: {
        get() {
          return this.$refs.genericTable.localItems;
        }
      }
    },
    methods: {
      refreshTable() {
        return this.$refs.genericTable.refresh();
      },
      saveFilters(tempFlag) {
        if (this.$refs.genericToolbar) {
          return this.$refs.genericToolbar.save(tempFlag);
        }
      },
      loadFilters(allowTempFlag) {
        if (this.$refs.genericToolbar) {
          return this.$refs.genericToolbar.load(allowTempFlag);
        }
      },
      cleared(filters, sortBy, sortDesc) {
        this.currentSortBy = sortBy;
        this.currentSortDesc = sortDesc;
        this.$refs.genericToolbar.cleared(filters, sortBy, sortDesc);
        this.$refs.genericTable.refresh();
      },
      isFieldExportable(field) {
        if (!field.key || !field.label) {
          return false;
        }
        if (['actions', 'action'].indexOf(field.key) >= 0) {
          return false;
        }
        return true;
      },
      massageExportValue(value) {
        value = value || '';
        return window.appHelpers.text.replace(window.appHelpers.text.replace(window.appHelpers.text.replace(value, '"', '*QUOT*'), '*QUOT*', '""', '\n', ' ')).toString();
      },
      exportData(withCustomizations) {
        appHelpers.audit.logExport(this.tableKey, this.exportKey);
        window.appHelpers.loader.start();
        let promise = null;
        if (this.getExportDataOverride) {
          promise = this.getExportDataOverride();
        } else {
          promise = this.getExportData();
        }
        return promise.then((items) => {
          this.massageExport(items, withCustomizations);
        }, (errorContainer) => {
          if (this.alert) {
            let errorMessages = appHelpers.message.getFromResponse(errorContainer);
            this.alert(null, true);
            errorMessages.forEach((errorMessage) => {    
              this.alert(appHelpers.message.create(errorMessage));
            });
          }
        }).finally(() => {
          window.appHelpers.loader.stop();
        });
      },
      getExportData() {
        return Promise.resolve(this.$refs.genericTable.localItems);
      },
      massageExport(items, withCustomizations) {
        let csvLines = [];
        let csvLine = [];
        let exportFields = withCustomizations ? this.massagedFields : this.fields;
        exportFields.forEach((field) => {
          if (this.isFieldExportable(field)) {
            csvLine.push(`"${this.massageExportValue(field.label)}"`);
          }
        });
        csvLines.push(csvLine.join(','));
        items.forEach((item) => {
          csvLine = [];
          exportFields.forEach((field) => {
            if (this.isFieldExportable(field)) {
              let rawValue = null;
              let fieldKeys = field.key.split('.');
              let currentItem = item;
              for (let fieldKeyIndex in fieldKeys) {
                let fieldKey = fieldKeys[fieldKeyIndex];
                if (!currentItem) {
                  break;
                }
                if (fieldKeyIndex == fieldKeys.length - 1) {
                  rawValue = currentItem[fieldKey];
                } else {
                  currentItem = currentItem[fieldKey];
                }
              }
              let formattedValue = field.formatter ? field.formatter(rawValue, field.key, item) : null;
              csvLine.push(`"${this.massageExportValue(formattedValue || rawValue)}"`);
            }
          });
          csvLines.push(csvLine.join(','));
        });
        this.downloadExport(csvLines.join('\n'), withCustomizations);
      },
      downloadExport(csv, withCustomizations) {
        let downloadLink = document.createElement("a");
        let fileName = window.appHelpers.fileName.stripIllegalChars((this.exportKey || this.tableKey || 'generic-table-data')
          + (withCustomizations ? '-export-with-custom-' : '-export-') + dayjs().format('YYYYMMDDHHmm') + '.csv')
        downloadLink.download = fileName;
        downloadLink.href = "data:text/csv;charset=utf-8," + window.appHelpers.url.encode(csv);
        downloadLink.style.display + 'none';
        document.body.appendChild(downloadLink);
        downloadLink.dispatchEvent(new MouseEvent('click'));
        //downloadLink.click();
        setTimeout(() => { document.body.removeChild(downloadLink) }, 0);
      }
    },
    render(createElement) {
      let self = this;
      let tableScopedSlots = { };
      let toolbarScopedSlots = { };
      let maxRows = this.maxRowMultiplier ? (window.appState.standardSearchResultSize * this.maxRowMultiplier) : null;

      if (this.$scopedSlots) {
        for (var i in self.$scopedSlots) {
          let v = self.$scopedSlots[i];
          let scopeName = i.toString();
          switch (scopeName.toLowerCase()) {
            case "info":
              break;
            case "toolbar-buttons":
              toolbarScopedSlots[i] = v;
              break;
            default:
              tableScopedSlots[i] = v;
          }
        }
      }

      let columns = [
      ];

      if (!self.hideToolbar) {
        columns.push(createElement(
          'div', {
            attrs: {
              class: 'col-sm-12'
            },
          }, [
            createElement(
              'generic-table-toolbar', {
                props: {
                  fields: self.fields,
                  sortBy: self.syncedSortBy,
                  sortDesc: self.syncedSortDesc,
                  search: self.search,
                  clear: self.clear,
                  alert: self.alert,
                  filters: self.filters,
                  tableKey: self.tableKey,
                  hideSearchResetButtons: self.hideSearchResetButtons,
                  hideDefaultParameters: self.hideDefaultParameters,
                  hideExport: self.hideExport,
                  allowColumnCustomization: self.allowColumnCustomization,
                  tableId: self.tableId,
                  exportKey: self.exportKey,
                  toolbarButtonSize: self.toolbarButtonSize
                },
                scopedSlots: toolbarScopedSlots,
                on: {
                  'update:filters'(newValue) {
                    self.syncedFilters = newValue;
                  },
                  'update:sortBy'(newValue) {
                    self.syncedSortBy = newValue;
                  },
                  'update:sortDesc'(newValue) {
                    self.syncedSortDesc = newValue;
                  },
                  'fieldsChanged'() {
                    self.fieldToggles = window.appHelpers.table.getFieldToggles(self.tableKey, window.appState.currentTenantId, self.tableId);
                    self.$forceUpdate();
                  },
                  'exportData'(withCustomizations) {
                    window.appHelpers.loader.start();
                    self.exportData(withCustomizations).finally(() => {
                      window.appHelpers.loader.stop();
                    });
                  }
                },
                ref: 'genericToolbar'
              }
            )
          ]
        ));
      }

      if (self.$scopedSlots.info) {
        columns.push(createElement(
          'div', {
            attrs: {
              class: 'col-sm-12'
            }
          }, [
            self.$scopedSlots.info({})
          ]
        ));
      }

      columns.push(createElement(
        'div', {
          attrs: {
            class: 'col-sm-12'
          }
        }, [
          createElement(
            'b-table', {
              props: {
                items: self.items,
                fields: self.massagedFields,
                currentPage: self.currentPage,
                perPage: self.perPage,
                busy: self.syncedBusy,
                sortBy: self.syncedSortBy,
                sortDesc: self.syncedSortDesc,
                stacked: self.tableStacked,
                responsive: self.tableResponsive,
                stickyHeader: self.tableStickyHeader,
                striped: true,
                hover: true,
                noBorderCollapse: true,
                footClone: self.footClone,
                filter: self.filterString,
                filterFunction: self.filterFunction,
                noProviderPaging: self.maxRowMultiplier ? true: false,
                tableClass: self.tableClass,
                filterIncludedFields: self.visibleFieldNames,
              },
              on: {
                'update:busy'(newValue) {
                  self.syncedBusy = newValue;
                },
                'update:sortBy'(newValue) {
                  self.syncedSortBy = newValue;
                },
                'update:sortDesc'(newValue) {
                  self.syncedSortDesc = newValue;
                },
                'filtered'(items) {
                  self.$emit('filtered', items);
                }
              },
              scopedSlots: tableScopedSlots,
              ref: 'genericTable'
            }
          )
        ]
      ));

      if (!self.hidePagination && (self.perPage || 0) !== 0)
      {
        columns.push(createElement(
          'div', {
            attrs: {
              class: 'col-md-6'
            }
          }, [createElement(
            'b-pagination', {
              props: {
                totalRows: (maxRows ? Math.min(maxRows, self.totalRows) : self.totalRows),
                perPage: self.perPage, 
                value: self.currentPage,
              },
              domProps: {
                class: 'my-0'
              },
              on: {
                'update:totalRows'(newValue) {
                  self.syncedTotalRows = newValue;
                },
                'update:pageSize'(newValue) {
                  self.syncedPageSize = newValue;
                },
                'input'(newValue) {
                  self.syncedCurrentPage = newValue;
                }
              }
            }
          ), (maxRows && self.totalRows)
            ? createElement(
              'small', { domProps: { class: 'text-muted' } }, maxRows < self.totalRows ? `Note: Displaying only the first ${maxRows} rows of results.` : `Note: Displaying all ${self.totalRows} rows of results.`
            )
            : null
          ]
        ));
      }

      return createElement(
        'div', {
          attrs: {
            class: 'row'
          }
        }, columns 
      )
    },
  };
</script>